var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SAIPageWrapper',[_c('div',{staticClass:"row items-center justify-center q-mt-xl"},[_c('h4',{staticClass:"text-grey-8"},[_vm._v("Quote Not Found")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }